import { render, staticRenderFns } from "./mineCouponsixth.vue?vue&type=template&id=2354fc00&scoped=true"
import script from "./mineCouponsixth.vue?vue&type=script&lang=js"
export * from "./mineCouponsixth.vue?vue&type=script&lang=js"
import style0 from "./mineCouponsixth.vue?vue&type=style&index=0&id=2354fc00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354fc00",
  null
  
)

export default component.exports